<template>
  <div class="kris-documents-box">
    <ul class="kris-doclist" v-if="data.hasOwnProperty('files')">
      <file v-for="item in data.files.Acc"
        :title="item.attribute_name"
        :link="'https://st.educom.ru' + item.val.url"
        ext="pdf"
      />
      <file  v-for="item in data.files.Acc_Addit"
        :title="item.attribute_name"
        :link="'https://st.educom.ru' + item.val.url"
        ext="pdf"
      />
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import File from './File'
export default {
  name: 'Accred',
  components: {
    'file': File
  },
  computed: {
    ...mapState({
      data: 'dataAkkred'
    })
  },
  created () {
    this.$store.dispatch('getDataAkkred')
  }
}
</script>

<style scoped>

</style>
